'use client';

import { useStore } from '@/store/store';
import { classes } from '@/utils/classes/classes';
import { useGlobalContext } from '@/store/contexts/global-context';
import { SvgLoader } from '@/app/elements/svg/loader';

type SwjBorderOverlayProps = {
    isSiteWideJackpot?: boolean;
    swjLabel?: 'default' | 'small';
    /** When true, adds no-animation class (e.g. for simplified row, matching casino-web). */
    noAnimation?: boolean;
};

export const SwjBorderOverlay = ({ isSiteWideJackpot, swjLabel, noAnimation = false }: SwjBorderOverlayProps) => {
    const multiplier = useStore((state) => state.siteWideJackpot.multiplier);
    const isSwjGame = Boolean(swjLabel) && Boolean(isSiteWideJackpot);
    const isOptedIn = multiplier > 0;
    const { swjTickerRedesignVariant } = useGlobalContext();
    const isOldSWJDesign = swjTickerRedesignVariant === 'control';
    const isNewSWJDesign = swjTickerRedesignVariant === 'variant-1';

    if (!isSwjGame || !isOptedIn) {
        return null;
    }

    if (isOldSWJDesign) {
        return (
            <div className={classes('site-wide-jackpot-opted-in', 'double-your-bet', noAnimation && 'no-animation')} />
        );
    }

    if (isNewSWJDesign) {
        return (
            <div className={classes('double-your-bet-opted-in')}>
                {multiplier === 1 ? (
                    <SvgLoader iconName="site-wide-jackpot-checkmark" width={26} height={26} directory="swj-icons" />
                ) : (
                    <SvgLoader iconName="site-wide-jackpot-bolt-radio" width={26} height={26} directory="swj-icons" />
                )}
            </div>
        );
    }

    return null;
};
